/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../../../core/components';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifyService } from '../../../../../../core/services';
import { Observable } from 'rxjs';
import { SystemApiService } from '../../../../shared/http';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-manual-update',
    templateUrl: './manualUpdate.component.html',
})
export class ManualUpdateComponent extends BaseComponent {
    /**
     * Upload form.
     * @private
     */
    public uploadForm: FormGroup;

    /**
     * To store the manual upload file.
     * @private
     */
    private manualUploadFile: File;

    constructor(
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private notifyService: NotifyService,
        private router: Router,
        private systemService: SystemApiService
    ) {
        super();

        this.setUpForm();
    }

    /**
     * Set up upload form
     * @private
     */
    private setUpForm(): void {
        this.uploadForm = this.formBuilder.group({
            file: [null, Validators.required],
        });
    }

    /**
     * To update the manual uploaded file.
     * @param event
     */
    public onFileChange(event) {
        this.manualUploadFile = event.target.files[0];
    }

    /**
     * Submit the manual update file.
     */
    public submitUpload(): Observable<any> {
        return new Observable<any>(observer => {
            this.systemService.manualUpdate(this.manualUploadFile)
                .pipe(takeUntil(this.destroyed$))
                .subscribe(
                    () => {
                        this.router.navigate(['..', { relativeTo: this.route }]).then();
                        observer.next();
                        observer.complete();
                    },
                    error => {
                        // Show the error on our page so we know
                        this.notifyService.error(error.message);
                        observer.error(error);
                        observer.complete();
                    }
                );
        });
    }
}
